export const renderDuBloodGroup = (bloodGroup) => {
  const bg = (bloodGroup || "-").trim();
  const duIdx = bg.search(/\s*Du\+/i);
  if (duIdx === -1) {
    return <span style={{ textTransform: "uppercase" }}>{bg}</span>;
  }
  return (
    <span style={{ textTransform: "uppercase" }}>
      {bg.slice(0, duIdx)}
      <sup style={{ fontSize: "0.72em", fontWeight: "normal", letterSpacing: 0 }}>
        Du+
      </sup>
    </span>
  );
};

export const getDonorBadgeInfo = (bloodGroup = "unspecified") => {
  if (!bloodGroup) return;

  const baseGroup = bloodGroup.replace(/\s*Du\+.*$/i, "").trim();
  let color;

  switch (baseGroup.toUpperCase()) {
    case "A+":
    case "A-":
      color = "yellow";
      break;
    case "AB+":
    case "AB-":
      color = "pink";
      break;
    case "B+":
    case "B-":
      color = "white";
      break;
    case "O+":
    case "O-":
      color = "green";
      break;
    default:
      break;
  }

  return { color, bloodGroup };
};
